import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Col } from 'reactstrap';

const Image = ({ imageUrl, height }) => (
  <Col lg="7" xs="12" className="empty-state-image">
    <div className="position-relative">
      <img
        src="/images/empty-pages/shape1-bg.svg"
        alt=""
        className="position-absolute w-100 h-100 image-shape"
      />
      <img
        src={imageUrl}
        alt=""
        className={classnames('img-fluid position-relative image-main', {
          'image-high': height === 'high',
          'image-low': height === 'low',
        })}
      />
    </div>
  </Col>
);

Image.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  height: PropTypes.string,
};

Image.defaultProps = {
  height: '',
};

export default Image;
